module.exports = __webpack_public_path__ + "static/media/icono_parlante.cc47d047.webp";